import React from "react";
import PropTypes from "prop-types";

const StickerNew = ({ className, color }) => (
  <svg className={className} viewBox="0 0 227 213">
    <defs>
      <polygon id="path-1" points="0 0 227 0 227 212 0 212"></polygon>
    </defs>
    <g id="Store" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Desktop" transform="translate(-982.000000, -3781.000000)">
        <g id="Group-3" transform="translate(670.000000, 3781.078125)">
          <g id="Sticker-save" transform="translate(312.000000, 0.000000)">
            <g id="Group-3">
              <mask id="mask-2" fill="white">
                <use xlinkHref="#path-1"></use>
              </mask>
              <g id="Clip-2"></g>
              <g id="Group-4" mask="url(#mask-2)">
                <path
                  d="M128.218098,4.08536117 L132.540236,2.24507814 C145.825991,-3.40721973 161.460941,1.97023068 167.793965,14.3682413 L169.855438,18.4043166 C174.316695,27.1396861 182.52781,33.6493885 192.405178,36.2813518 L196.967611,37.5002405 C210.990058,41.240556 219.308673,54.8514805 215.726388,68.1965199 L214.559696,72.5403049 C212.036604,81.9418807 213.895724,91.9110762 219.669115,99.9294523 L222.34081,103.633918 C230.536116,115.016188 227.646259,130.494283 215.824403,138.542534 L211.973368,141.162547 C203.645268,146.829782 198.28923,155.598014 197.258494,165.244562 L196.784228,169.704859 C195.320329,183.40242 182.572075,193.506052 168.043745,192.490311 L163.316899,192.158702 C153.07909,191.441708 143.008855,194.907176 135.657741,201.673801 L132.255677,204.798698 C121.818677,214.400434 105.181446,214.400434 94.7412837,204.798698 L91.3455434,201.673801 C83.9912679,194.907176 73.9210325,191.441708 63.686385,192.158702 L58.9563781,192.490311 C44.4248861,193.506052 31.6797938,183.40242 30.2190563,169.704859 L29.7416291,165.244562 C28.7108923,155.598014 23.3516933,146.829782 15.0235928,141.162547 L11.1757194,138.542534 C-0.649297982,130.494283 -3.53599341,115.016188 4.66247455,103.633918 L7.33100789,99.9294523 C13.1043987,91.9110762 14.9666809,81.9418807 12.4404272,72.5403049 L11.2737343,68.1965199 C7.6914496,54.8514805 16.0100648,41.240556 30.0293502,37.5002405 L34.5981069,36.2813518 C44.4754744,33.6493885 52.6802659,27.1396861 57.1446842,18.4043166 L59.2061578,14.3682413 C65.5391819,1.97023068 81.1709696,-3.40721973 94.4567245,2.24507814 L98.782025,4.08536117 C108.140862,8.06467447 118.856099,8.06467447 128.218098,4.08536117"
                  id="Fill-1"
                  fill="#EF5518"
                ></path>
                <text
                  id="Sold-out"
                  fontFamily="OrLemmen-Regular, Or Lemmen"
                  fontSize="51"
                  fontWeight="normal"
                  fill="#F0DFD2"
                >
                  <tspan x="62.2821387" y="100.158385">
                    Sold{` `}
                  </tspan>
                  <tspan x="77.6841387" y="149.158385">
                    out
                  </tspan>
                </text>
              </g>
              <g id="Group-4" mask="url(#mask-2)">
                <path
                  d="M132.540236,2.24507814 C145.825991,-3.40721973 161.460941,1.97023068 167.793965,14.3682413 L169.855438,18.4043166 C174.316695,27.1396861 182.52781,33.6493885 192.405178,36.2813518 L196.967611,37.5002405 C210.990058,41.240556 219.308673,54.8514805 215.726388,68.1965199 L214.559696,72.5403049 C212.036604,81.9418807 213.895724,91.9110762 219.669115,99.9294523 L222.34081,103.633918 C230.536116,115.016188 227.646259,130.494283 215.824403,138.542534 L211.973368,141.162547 C203.645268,146.829782 198.28923,155.598014 197.258494,165.244562 L196.784228,169.704859 C195.320329,183.40242 182.572075,193.506052 168.043745,192.490311 L163.316899,192.158702 C153.07909,191.441708 143.008855,194.907176 135.657741,201.673801 L132.255677,204.798698 C121.818677,214.400434 105.181446,214.400434 94.7412837,204.798698 L91.3455434,201.673801 C83.9912679,194.907176 73.9210325,191.441708 63.686385,192.158702 L58.9563781,192.490311 C44.4248861,193.506052 31.6797938,183.40242 30.2190563,169.704859 L29.7416291,165.244562 C28.7108923,155.598014 23.3516933,146.829782 15.0235928,141.162547 L11.1757194,138.542534 C-0.649297982,130.494283 -3.53599341,115.016188 4.66247455,103.633918 L7.33100789,99.9294523 C13.1043987,91.9110762 14.9666809,81.9418807 12.4404272,72.5403049 L11.2737343,68.1965199 C7.6914496,54.8514805 16.0100648,41.240556 30.0293502,37.5002405 L34.5981069,36.2813518 C44.4754744,33.6493885 52.6802659,27.1396861 57.1446842,18.4043166 L59.2061578,14.3682413 C65.5391819,1.97023068 81.1709696,-3.40721973 94.4567245,2.24507814 L98.782025,4.08536117 C108.140862,8.06467447 118.856099,8.06467447 128.218098,4.08536117 L132.540236,2.24507814 Z"
                  id="Fill-1"
                  fill="#00AF8D"
                ></path>
                <text
                  id="Save"
                  transform="translate(114.251656, 103.744681) rotate(-330.000000) translate(-114.251656, -103.744681) "
                  fontFamily="OrLemmen-Regular, Or Lemmen"
                  fontSize="51"
                  fontWeight="normal"
                  fill="#F0DFD2"
                >
                  <tspan x="55.5506556" y="119.744681">
                    Save
                  </tspan>
                </text>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

StickerNew.defaultProps = {
  className: ``,
  color: `black`
};

StickerNew.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string
};

export default StickerNew;
